import { useState } from 'react';
import { DropdownMenuFilter } from '../../../../components/ui/dropdown-menu/DropdownMenuFIlter';
import { useGetAllGamesQuery } from '../../../../slices/gameApiSlice';
import { LoadingSceletonGameAllTeams } from '../../../tournaments/routes/all/loading-sceleton-gameallteams';
import { useGetAllTeamsQuery } from '../../../../slices/teamsApiSlice';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { BsFillTrashFill } from 'react-icons/bs';
import CanIView from '../../../../components/can-i-view/can-i-view';
import { HeaderButton } from '../../../../components/header-button';
import TeamCard from '../../../../components/dashboard/team-card';

const OgmaDashboardTeams = () => {
  const [selectedGames, setSelectedGames] = useState<string[]>([]);
  const [showOnlyIncompleteTeams, setShowOnlyIncompleteTeams] = useState(false);
  const [showMy, setShowMy] = useState(true);

  const {
    data: teamData,
    isLoading,
    error,
  } = useGetAllTeamsQuery({ query: {}, noPagination: true, showMy });
  const { data: gameData, isLoading: gameIsLoading, error: gameError } = useGetAllGamesQuery({});

  const handleGameFilterChange = (games: string[]) => {
    setSelectedGames(games);
  };

  const processedTeams = teamData?.map((team: any) => {
    const seasonName = team.season[0]?.name;
    const isFullMembers = team.activeMembers.length >= team.Game.active_limit;
    const numPlayersWithInGameName = team.User.filter((player: any) =>
      player.InGameName.some((name: any) => name.game_id === team.game_id),
    ).length;
    const isFullInGameNames = numPlayersWithInGameName >= team.activeMembers.length;
    const isTeamFlagged = !seasonName || !isFullMembers || !isFullInGameNames;

    return {
      ...team,
      isTeamFlagged,
      seasonName,
      isFullMembers,
      numPlayersWithInGameName,
      isFullInGameNames,
    };
  });

  const teamsWithIssuesCount = processedTeams?.filter(
    (team: any) =>
      team.isTeamFlagged && (!selectedGames.length || selectedGames.includes(team.Game.name)),
  ).length;

  const teamsByGame: Record<string, Array<any>> = processedTeams?.reduce(
    (acc: Record<string, Array<any>>, team: any) => {
      const gameName = team.Game?.name || 'Unknown Game';
      if (!acc[gameName]) {
        acc[gameName] = [];
      }
      acc[gameName].push(team);
      return acc;
    },
    {},
  );

  const headerButtons = [
    {
      type: 'newTeam',
      canIview: 'team.newTeam',
    },
  ];
  if (isLoading || gameIsLoading) return <LoadingSceletonGameAllTeams />;
  return (
    <div>
      <div className='flex items-center justify-between mb-4'>
        <div className='flex '>
          <div
            className='button hover:bg-opacity-80 w-fit bg-fen-blue mr-4'
            onClick={() => {
              setShowMy(!showMy);
            }}
          >
            {showMy ? 'My Teams' : 'All Teams'}
          </div>
          <DropdownMenuFilter
            title='Titles'
            items={
              gameData?.map((game: any, index: number) => ({
                label: game.name,
                defaultChecked: selectedGames.includes(game.name),
              })) ?? []
            }
            onClear={() => {
              setSelectedGames([]);
            }}
            onChange={(checkedItems) => {
              const games = checkedItems
                .filter((item) => item.defaultChecked)
                .map((item) => item.label);
              handleGameFilterChange(games);
            }}
          />
          {(selectedGames.length || showOnlyIncompleteTeams) && (
            <button
              onClick={() => {
                setSelectedGames([]);
                setShowOnlyIncompleteTeams(false);
              }}
              className='bg-gray-300 text-black mx-2 px-4 py-2 rounded-md hover:bg-gray-500 hover:text-white'
            >
              Clear Filters
            </button>
          )}
        </div>
        {headerButtons.map(({ canIview, ...others }, i: number) =>
          canIview ? (
            <CanIView key={i} component={canIview}>
              <HeaderButton {...others} />
            </CanIView>
          ) : (
            <HeaderButton {...others} key={i} />
          ),
        )}
      </div>
      {teamsWithIssuesCount ? (
        <h1
          onClick={() => setShowOnlyIncompleteTeams(!showOnlyIncompleteTeams)}
          className={`flex justify-self-center text-lg font-semibold text-fen-red w-fit bg-gray-200 px-4 py-2 rounded-md cursor-pointer hover:bg-gray-300 hover:shadow-md ${
            showOnlyIncompleteTeams ? 'bg-gray-300' : ''
          }`}
        >
          {teamsWithIssuesCount} Team{teamsWithIssuesCount !== 1 ? 's Have' : ' Has'} an Issue
        </h1>
      ) : null}
      {teamsByGame ? (
        Object.entries(teamsByGame).map(([gameName, teams]) => (
          <div key={gameName}>
            {(!selectedGames.length || selectedGames.includes(gameName)) && (
              <div key={gameName} className='mb-8'>
                {/* Game Section Header */}
                <h2 className='text-xl font-semibold mb-3'>{gameName}</h2>
                <div className='grid grid-cols-3 gap-4'>
                  {teams
                    .sort((a: any, b: any) => b.isTeamFlagged - a.isTeamFlagged)
                    .filter((team: any) => {
                      if (showOnlyIncompleteTeams) {
                        return team.isTeamFlagged;
                      }
                      return true;
                    })
                    .map((team: any) => {
                      return <TeamCard key={team.id} team={team} />;
                    })}
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <p>No teams found.</p>
      )}
      <Outlet />
    </div>
  );
};

export default OgmaDashboardTeams;
